import WebServiceWrapper from "./WebServiceWrapper";

export const AbstractorService = {
    GetAllAbstractors, SaveAbstractor,DeleteAbstractor,UpdateAbstractorStatus
};

function GetAllAbstractors() {
  return WebServiceWrapper.Get(`/abstractor/GetAllAbstractors`);
}
function SaveAbstractor(payload) {
    return WebServiceWrapper.Post("/abstractor/SaveAbstractor",payload);
}
function DeleteAbstractor(abstractorId) {
  return WebServiceWrapper.Get(`/abstractor/DeleteAbstractor?abstractorId=${abstractorId}`);
}
function UpdateAbstractorStatus(payload) {
  return WebServiceWrapper.Post("/abstractor/UpdateAbstractorStatus",payload);
}


